import React from 'react';

export const ListaUsu = () => {
	return [
		{
			fotoUsuario: '',
			nombreUsuario: 'Juan',
			idUsuario: '74320985',
			telefonoUsuario: '633333333',
			correoUsuario: 'usuario123@correro.com',
			telefonoUsuario2: '600300300',
			nombreUsu: 'Juanito',
		},
		{
			fotoUsuario: '',
			nombreUsuario: 'Juan Antonio',
			idUsuario: '74320985',
			telefonoUsuario: '644444444',
			correoUsuario: 'usuario123@correro.com',
			telefonoUsuario2: '600400400',
			nombreUsu: 'JuanAnton',
		},
		{
			fotoUsuario: '',
			nombreUsuario: 'Roberto',
			idUsuario: '74320985',
			telefonoUsuario: '655555555',
			correoUsuario: 'usuario123@correro.com',
			telefonoUsuario2: '600500500',
			nombreUsu: 'rober96',
		},
		{
			fotoUsuario: '',
			nombreUsuario: 'Alberto',
			idUsuario: '74320985',
			telefonoUsuario: '666666666',
			correoUsuario: 'usuario123@correro.com',
			telefonoUsuario2: '600600600',
			nombreUsu: 'albertonSS',
		},
		{
			fotoUsuario: '',
			nombreUsuario: 'Juasadfn',
			idUsuario: '743209asdf85',
			telefonoUsuario: '633333433',
			correoUsuario: 'usuarido123@correro.com',
			telefonoUsuario2: '600302300',
			nombreUsu: 'Juandito',
		},
		{
			fotoUsuario: '',
			nombreUsuario: 'Judan Antonio',
			idUsuario: '7432230985',
			telefonoUsuario: '64444423444',
			correoUsuario: 'usuario1223@correro.com',
			telefonoUsuario2: '60042300400',
			nombreUsu: 'JuanAsdfnton',
		},
		{
			fotoUsuario: '',
			nombreUsuario: 'Robdsferto',
			idUsuario: '7432032985',
			telefonoUsuario: '65555555we5',
			correoUsuario: 'usuario12we3@correro.com',
			telefonoUsuario2: '60050023500',
			nombreUsu: 'robsdfer96',
		},
		{
			fotoUsuario: '',
			nombreUsuario: 'Albsdferto',
			idUsuario: '7432230985',
			telefonoUsuario: '66666324666',
			correoUsuario: 'usuario1f23@correro.com',
			telefonoUsuario2: '600600600',
			nombreUsu: 'albdfertonSS',
		},
	];
};
